import React from 'react'
import AssessmentProgress from "../../assessment-progress"

export default function index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Great <span class="highlight1">Work!</span>
        </div>
        <div className="assessment1-content">
          Click next to begin the next exercise to put your cognitive skills to the test!
        </div>

        <AssessmentProgress progress={props.progress} />

        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Next
        </div>
      </div>
    </div>
  )
}
